import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Debug from 'debug';

const debug = Debug('aumico:aumico-lib-core-fe:AumMenu');

export interface IAumMenuOptions {
    items: IAumMenuItem[];
    actionButtons?: IAumMenuItem[];
}
export interface IAumMenuItem {
    caption: string;
    action: string;
    icon?: string;
    disabled?: boolean;
}

export interface IAumMenuDelegate {
    onMenuItemClick(action: string, item?: IAumMenuItem, event?: Event, entity?: any): void;
}

@Component({
    selector: 'aum-menu',
    styleUrls: ['./menu.scss'],
    templateUrl: './menu.html',
    encapsulation: ViewEncapsulation.Emulated,
    host: {
        class: 'aum-menu',
    },
})
export class AumMenu {
    @Input() items: IAumMenuItem[];
    @Input() entity?: any;
    DELEGATE?: IAumMenuDelegate;
    @Input() public set delegate(delegate: IAumMenuDelegate) {
        if (delegate) {
            this.DELEGATE = delegate;
        }
    }
    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        //TODO, this should only be added on a global space
        this.addSvgIcon('aumico-pattern-icon-add-circle');
        this.addSvgIcon('aumico-pattern-icon-settings-vertical');
    }

    onClick(item: IAumMenuItem, event: Event) {
        debug('onClick', item, event);
        if (this.DELEGATE) {
            this.DELEGATE.onMenuItemClick(item.action, item, event, this.entity);
        }
    }

    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
